import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, api } from '../context/AuthContext';

const PROVINCES = ['SAN_JOSE', 'ALAJUELA', 'HEREDIA', 'CARTAGO', 'GUANACASTE', 'PUNTARENAS', 'LIMON'];

export default function CreateWant() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [form, setForm] = useState({
    title: '', description: '', brand: '',
    budget_min: '', budget_max: '', province: 'SAN_JOSE'
  });

  useEffect(() => {
    fetch('/api/brands/visible')
      .then(r => r.json())
      .then(d => setBrands([...(d.brands || []), 'Otro']))
      .catch(() => setBrands(['Honda', 'Yamaha', 'Kawasaki', 'Suzuki', 'KTM', 'TVS', 'Bajaj', 'AKT', 'Otro']));
  }, []);

  const handleImages = (e) => {
    const files = Array.from(e.target.files).slice(0, 4);
    setImages(files);
    setPreviews(files.map(f => URL.createObjectURL(f)));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) { navigate('/login'); return; }
    setLoading(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (v) fd.append(k, v); });
      images.forEach(img => fd.append('images', img));
      await api.post('/wants', fd);
      navigate('/wants');
    } catch (err) {
      alert(err?.response?.data?.error || 'Error al crear solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <div className="bg-primary text-white py-8">
        <div className="max-w-2xl mx-auto px-4">
          <h1 className="text-3xl font-bold">🔍 Busco esta pieza</h1>
          <p className="text-white/80 mt-2">Describe lo que necesitas y te contactarán</p>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 py-8">
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
          <div>
            <label className="block font-medium mb-2">¿Qué estás buscando? *</label>
            <input type="text" value={form.title} onChange={e => setForm({...form, title: e.target.value})}
              className="w-full border-2 rounded-xl px-4 py-3 focus:border-primary focus:outline-none"
              placeholder="Ej: Bobina de encendido Honda CB190R" required />
          </div>

          <div>
            <label className="block font-medium mb-2">Marca de moto</label>
            <select value={form.brand} onChange={e => setForm({...form, brand: e.target.value})}
              className="w-full border-2 rounded-xl px-4 py-3 focus:border-primary focus:outline-none">
              <option value="">Selecciona la marca</option>
              {brands.map(b => <option key={b} value={b}>{b}</option>)}
            </select>
          </div>

          <div>
            <label className="block font-medium mb-2">Descripción</label>
            <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})}
              className="w-full border-2 rounded-xl px-4 py-3 focus:border-primary focus:outline-none"
              rows="4" placeholder="Describe detalles, año, modelo, estado, etc." />
          </div>

          <div>
            <label className="block font-medium mb-2">Fotos de referencia (máx. 4)</label>
            <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-xl cursor-pointer hover:border-primary transition">
              <span className="text-3xl mb-1">📷</span>
              <span className="text-sm text-gray-500">Haz clic para subir fotos</span>
              <input type="file" accept="image/*" multiple className="hidden" onChange={handleImages} />
            </label>
            {previews.length > 0 && (
              <div className="flex gap-2 mt-3 flex-wrap">
                {previews.map((src, i) => (
                  <img key={i} src={src} className="w-20 h-20 object-cover rounded-lg border" />
                ))}
              </div>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block font-medium mb-2">Presupuesto mínimo (₡)</label>
              <input type="number" value={form.budget_min} onChange={e => setForm({...form, budget_min: e.target.value})}
                className="w-full border-2 rounded-xl px-4 py-3 focus:border-primary focus:outline-none" placeholder="50000" />
            </div>
            <div>
              <label className="block font-medium mb-2">Presupuesto máximo (₡)</label>
              <input type="number" value={form.budget_max} onChange={e => setForm({...form, budget_max: e.target.value})}
                className="w-full border-2 rounded-xl px-4 py-3 focus:border-primary focus:outline-none" placeholder="150000" />
            </div>
          </div>

          <div>
            <label className="block font-medium mb-2">Ubicación</label>
            <select value={form.province} onChange={e => setForm({...form, province: e.target.value})}
              className="w-full border-2 rounded-xl px-4 py-3 focus:border-primary focus:outline-none">
              {PROVINCES.map(p => <option key={p} value={p}>{p.replace('_', ' ')}</option>)}
            </select>
          </div>

          <button type="submit" disabled={loading}
            className="w-full bg-primary text-white font-bold py-4 rounded-xl hover:bg-primary-dark transition disabled:opacity-50">
            {loading ? 'Publicando...' : 'Publicar Solicitud'}
          </button>
        </form>
      </div>
    </div>
  );
}
